import DestinationPicker from '@/src/vue/components/DestinationPicker/DestinationPicker.vue';
import { createVueApp } from '@/src/vue/utils/createVueApp';
import { documentReady } from '@js/utils/toolbox';
import breakpoints from '@/src/vue/plugins/breakpoints';

documentReady(() => {
	console.log('DestinationPicker mounted', DestinationPicker);
	const vueApp = createVueApp(DestinationPicker, {});
	vueApp.use(breakpoints);
	vueApp.mount('[data-destination-picker]');
});
